module.exports = __webpack_public_path__ + "static/media/ben-white.24269ffc.jpg";